import { withInstall } from '../../../../utils/with-install'
import Buildings from './Buildings.vue'

export const ElAmapLayerBuildings = withInstall(Buildings)
export default ElAmapLayerBuildings
